import script from "./sideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./sideBar.vue?vue&type=script&setup=true&lang=js"

import "./sideBar.vue?vue&type=style&index=0&id=306901a2&lang=css"

const __exports__ = script;

export default __exports__